<template>
	<div>
		<v-data-table
			:headers="headers"
			:items="allRetailerList.list"
			:items-per-page="5"
			class="elevation-1"
		>
			lol
			<template v-slot:items="props">
				<tr>
					<td class="text-xs-center">
						{{ props.item.retailerName }}
					</td>
					<td class="text-xs-center">
						{{
							props.item.phoneNo
								? props.item.phoneNo.toString().slice(2)
								: ""
						}}
					</td>
					<td class="text-xs-center">
						{{ props.item.totalInputAmount }}
					</td>
					<td class="text-xs-center">
						{{ props.item.totalCommissionEarned }}
					</td>
					<td class="text-xs-center">
						{{ props.item.walletBalance }}
					</td>
					<td class="text-xs-center">{{ props.item.storeType }}</td>
				</tr>
			</template>
		</v-data-table>
		<v-layout row wrap class="justify-center my-3 px-2 pb-2">
			<div>
				<v-btn
					:color="themeInputColor"
					class="white--text"
					v-if="allRetailerList.offset"
					@click="fetchAllRetailersDstr({ type: END })"
					>Load More</v-btn
				>
			</div>
		</v-layout>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { TOP, END } from "@/store/config";

import { FETCH_ALL_DISTRIBUTOR_RETAILER_LIST } from "@/store/action-types";

export default {
	name: "RetailerDstrList",
	props: ["title", "themeInputColor"],
	data() {
		return {
			headers: [
				{
					text: "Name",
					value: "name",
					align: "center",
					sortable: false
				},
				{
					text: "Phone No",
					value: "phoneNo",
					align: "center",
					sortable: false
				},
				{
					text: "Total Input Amount",
					value: "totalInputAmount",
					align: "center",
					sortable: false
				},
				{
					text: "Total Commission",
					value: "totalCommissionEarned",
					align: "center",
					sortable: false
				},
				{
					text: "Wallet Balance",
					value: "walletBalance",
					align: "center",
					sortable: false
				},
				{
					text: "Store Type",
					value: "storeType",
					align: "center",
					sortable: false
				}
			],
			TOP,
			END
		};
	},
	mounted() {
		this.fetchAllRetailersDstr(TOP);
	},
	computed: {
		...mapState({
			allRetailerList: state => state.retail.allRetailerDstrList
		})
	},
	methods: {
		fetchAllRetailersDstr(payload) {
			this.$store.dispatch(
				FETCH_ALL_DISTRIBUTOR_RETAILER_LIST.dispatch,
				payload
			);
		}
	}
};
</script>
